import { Container } from "@chakra-ui/react";
import Layout from "../../../components/dashboard/Layout";
import LiveVideosReports from "../../../containers/superadmin/live-videos-reports";

const LiveVideosReportsPage = () => {
  return (
    <Layout>
      <Container maxW="container.xl" py={8}>
        <LiveVideosReports />
      </Container>
    </Layout>
  );
};

export default LiveVideosReportsPage;
